import {StyleSheet} from 'react-native';

import {onyxLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  CSBText: {
    paddingVertical: 8,
    color: onyxLight,
  },
});
